import type { TFunction } from 'i18next';

import { RELATIVE_PERIOD_I18N_KEY } from '@/modules/analytics/constants/timeRange';
import type { MetricRange } from '@/shared/types/reports';
import { formatDate } from '@/util/dateUtils';

const formatCustomLabel = (start: string, end: string) =>
  `${formatDate(start, 'MMM d, yyyy')} – ${formatDate(end, 'MMM d, yyyy')}`;

export const formatRangeLabel = (range: MetricRange, t: TFunction): string =>
  range.kind === 'custom'
    ? formatCustomLabel(range.start, range.end)
    : t(RELATIVE_PERIOD_I18N_KEY[range.period]);
